import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {Location} from '@angular/common';
import { TamasAlunoService } from '../tamas-aluno.service';
import { AlertaSimplesDialog } from '../alerta-simples';
import { AlertaConfirmDialog} from '../alerta-confirm';
import { Produto, CartItem } from '../tamas-models';
import {AlertaPremiumDialog} from '../alerta-premium';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';


@Component({
  selector: 'app-shop-avaliar',
  templateUrl: './shop-avaliar.component.html',
  styleUrls: ['./shop-avaliar.component.css']
})
export class ShopAvaliarComponent implements OnInit, OnDestroy {
  hideCL: boolean = false;
  categoriaAtual: any = '';
  idProduto: any = 0;
  mUF: any = '';
  mCidade: any = '';
  urlFoto: any = '';
  numPedidoAtual: any = 0
  arrPedProdutos: any[] = [];
  resumoPedido: any = '';
  resumoEntrega: any = '';
  urlECfoto: any = '';
  stars: number[] = [1, 2, 3, 4, 5];
  selectedValue: number = 0;
  indicaria: boolean = false;
  resenha: any = '';

  constructor(private route: ActivatedRoute, private _location: Location, public router: Router,  public tmaService: TamasAlunoService,  public dialog: MatDialog) { }

  ngOnInit() {
    this.hideCL = true;
    this.tmaService.eventoFS(true);
    this.numPedidoAtual = this.route.snapshot.paramMap.get('id');
  }


  ngOnDestroy(){
    this.tmaService.eventoFS(false);
  }


  countStar(star) {
    this.selectedValue = star;
    console.log('Value of star', star);

  }


  avaliar() :void{
    
    if(this.selectedValue == 0){
      const erroCriar = this.dialog.open(AlertaSimplesDialog, {
        disableClose:true,
        data: {textoAlerta: "Escolha entre 1 a 5 estrelas para avaliar", tituloAlerta: 'Aviso', iconAlerta: 'warning'}
      });
      return;
    }

    let customParams = {
      //lista: localStorage.getItem('turboCart'),
      email: this.tmaService.hcEmail,
      senha: this.tmaService.hcSenha,
      idpedido: this.numPedidoAtual, 
      nota: this.selectedValue,
      resenha: this.resenha,
      indicaria: this.indicaria
    };
    this.hideCL = false;
    this.tmaService.avaliarPedido(customParams).subscribe((qRes) =>{
      this.hideCL = true;
      console.log(qRes);
      if(qRes['res'] == 'done'){
        const avDone = this.dialog.open(AlertaConfirmDialog, {
          // width: '250px',
          disableClose: true,
          data: { tituloAlerta: "Obrigado", textoAlerta: "Avaliação realizada com sucesso!", textoConfirm: "OK" }
        });
        avDone.afterClosed().subscribe((result) => {
          this.voltar();
        });
      }
      else{
        const erroCriar = this.dialog.open(AlertaSimplesDialog, {
          disableClose:true,
          data: {textoAlerta: "Ocorreu um erro ao realizar a avaliação. Tente novamente", iconAlerta: 'warning'}
        });
      }
    },
    (error) =>{
      this.hideCL = true;
      const erroCriar = this.dialog.open(AlertaSimplesDialog, {
        disableClose:true,
        data: {textoAlerta: "Verifique sua conexão com a internet. Tente novamente", iconAlerta: 'warning'}
      });
    })

  }

  voltar() :void{
    //this._location.back();
    if(this.tmaService.paginaAnterior !== ''){
      this.router.navigate([this.tmaService.paginaAnterior]);
    }
    else{
      this.router.navigate(['home']);
    }
  }
}
